import styled from 'styled-components'

export const CardTitle = styled.div`
    font-size: 15px;
    font-weight: 700;
    color: ${props => props.theme.colors.textBold};
    margin-bottom: 5px;
` 